require("./toaster.js");
module.exports = "toaster";



//////////////////
// WEBPACK FOOTER
// /app/~/angularjs-toaster/index.js
// module id = 958
// module chunks = 38